// extracted by mini-css-extract-plugin
export default {"icon":"_18mSinnPFx","left":"_2U-Cdfa48U","right":"_1oybmwl5Ja"};
    if(module.hot) {
      // 1633091604692
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  